import { render, staticRenderFns } from "./wv-weekly-insights.vue?vue&type=template&id=4dc6891b&scoped=true&"
import script from "./wv-weekly-insights.vue?vue&type=script&lang=js&"
export * from "./wv-weekly-insights.vue?vue&type=script&lang=js&"
import style0 from "./wv-weekly-insights.vue?vue&type=style&index=0&id=4dc6891b&lang=scss&scoped=true&"
import style1 from "./wv-weekly-insights.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6891b",
  null
  
)

export default component.exports